
import { useCart } from '../../hooks/useCart';
import { useNavigate } from 'react-router-dom';

const CartIcon = () => {
  const { getItemCount } = useCart();
  const navigate = useNavigate();
  const itemCount = getItemCount();

  const handleCartClick = () => {
    navigate('/carrinho');
  };

  return (
    <button
      onClick={handleCartClick}
      className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200"
    >
      <i 
        className="ri-shopping-bag-line text-xl"
        style={{ color: '#0B0B0B' }}
      ></i>
      {itemCount > 0 && (
        <span 
          className="absolute -top-1 -right-1 w-5 h-5 text-xs font-bold text-white rounded-full flex items-center justify-center"
          style={{ 
            backgroundColor: '#0F3F2F',
            fontFamily: 'Montserrat, sans-serif'
          }}
        >
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </button>
  );
};

export default CartIcon;
